export default "__VITE_ASSET__CK_nhA8D__"